import React from 'react';
import { GoogleMap, Circle } from '@react-google-maps/api'; // Use the modern library
import { getZoom } from './getZoom';

type LatLng = {
    lat: number;
    lng: number;
};

type Props = {
    center?: LatLng;
    distance: number;
    mapContainerStyle: React.CSSProperties;
};

const Map: React.FC<Props> = ({ center, distance, mapContainerStyle }) => {
    if (!center) {
        return null; // Return nothing if no center is provided
    }

    return (
        <GoogleMap
            center={center}
            mapContainerStyle={{
                width: '100%',
                height: '100%',
                ...mapContainerStyle,
            }}
            options={{
                draggable: false,
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                zoomControl: false,
            }}
            zoom={getZoom(distance)} // Zoom level based on distance
        >
            {/* Only render the circle if distance is greater than 0 */}
            {distance !== 0 && (
                <Circle
                    center={center}
                    options={{
                        fillColor: 'blue',
                        fillOpacity: 0.3,
                        strokeColor: 'blue',
                        strokeOpacity: 0.7,
                        strokeWeight: 1,
                    }}
                    radius={distance * 1609.344} // Convert miles to meters
                />
            )}
        </GoogleMap>
    );
};

export { Map };
